import { ordenActions } from "./orden-slice";
import { uiActions } from "../ui-slice";
import { saveAs } from "file-saver";

export const CreateOrder = (order, userName) => {  
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Creando Orden",
        message: "Creando orden al servidor.",
      })
    );

    const createOrderInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/orden/create`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: userName,
            CourseId: order.courseId,
            DiscountCode: order.discountCode,
            Amount: order.amount,
            QuantityOfUsers: order.quantityOfUsers,
            RNC: order.rnc,
            TaxBill: order.taxBill,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {

        
        throw new Error("No se pudo crear la orden");
      }
      const data = await response.json();

      return data;
    };
    try {
      const response = await createOrderInfo();

      if (response.result.errorCode === "OK") {
        localStorage.removeItem("token");
        localStorage.setItem("token", response.data.token);
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Orden Creada",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          ordenActions.setOrden({
            orden: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
            
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo crear la orden",
        })
      );
    }
  };
};
export const UpdatePayment = (ordenId, userName, transacion) => {
  return async (dispatch) => {
    const updateOrderInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/orden/updatePayment`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: userName,
            Id: ordenId,
            Transaction: {
              ...transacion,
            },
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo actualizar la orden");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await updateOrderInfo();

      if (response.result.errorCode === "OK") {
        dispatch(
          ordenActions.setTransaction({
            transaction: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Se ha realizado el pago",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          ordenActions.setOrden({
            orden: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar la orden",
        })
      );
    }
  };
};
export const DownloadQuote = (userId, ordenId, userName) => {
  return async (dispatch) => {
    const updateOrderInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/user/downloadQuote`,
        {
          method: "POST",
          body: JSON.stringify({
            Id: userId,
            OrdenId: ordenId,
            UserName: userName,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo encontrar el certificado");
      }
      const data = await response.blob();
      const filename = response.headers.get("Content-Disposition");

      return { blob: data, filename };
    };
    try {
      const response = await updateOrderInfo();
      saveAs(response.blob, response.filename);
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo descargar el certificado",
        })
      );
    }
  };
};
export const CreateOrderByAdmin = (payOrder, userName, users, isConference) => {
  let usuarios = [];
  if (users !== undefined) {
    usuarios = users.map((usuario) => {
      return {
        Email: usuario.email,
        Nombres: usuario.nombres,
        Apellidos: usuario.apellidos,
        TelefonoCelular: usuario.telefonoCelular,
        Pais: usuario.pais,
        Ciudad: usuario.ciudad,
        Direccion: usuario.direccion,
        EntidadLabora: usuario.entidadLabora,
        Cargo: usuario.cargo,
        Departamento: usuario.departamento,
        Identificacion: usuario.identificacion,
      };
    });
  }
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Creando Orden",
        message: "Creando orden al servidor.",
      })
    );

    const createOrderInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}Orden/createByAdmin`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: userName,
            IsConference: isConference,
            Payload: {
              ...payOrder,
            },
            usuarios: users !== undefined ? usuarios : null,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {

        throw new Error("No se pudo crear la orden");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await createOrderInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          ordenActions.setOrden({
            orden: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Datos Cargados",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          ordenActions.setOrden({
            orden: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo crear la orden",
        })
      );
    }
  };
};
export const GetOrdensById = (OrdenId, UserName, courseId) => {
  return async (dispatch) => {
    const getOrdensInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/Orden/getOrdenById`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: UserName,
            Id: OrdenId,
            CourseId: courseId
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudieron obtener los usuarios");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getOrdensInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          ordenActions.setOrden({
            orden: response.data,
          })
        );
        // dispatch(
        //   uiActions.showNotification({
        //     status: "success",
        //     title: "Datos Cargados",
        //     message: response.result.message,
        //   })
        // );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          ordenActions.setOrden({
            orden: {},
          })
        );
        // dispatch(
        //   uiActions.showNotification({
        //     status: "warning",
        //     title: "Advertencia",
        //     message: response.result.message,
        //   })
        // );
      }
    } catch (error) {
      // dispatch(
      //   uiActions.showNotification({
      //     status: "error",
      //     title: "Error!",
      //     message: "No se pudo obtener las ordenes",
      //   })
      // );
    }
  };
};
export const GetOrdenByConferenceId = (UserName, ConferenceId) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Solicitando Ordenes",
        message: "Solicitando ordenes al servidor.",
      })
    );
    const getOrdensInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}training/Orden/getOrdenByConferenceId`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: UserName,
            ConferecenId: ConferenceId,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudieron obtener los usuarios");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getOrdensInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          ordenActions.setOrden({
            orden: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Datos Cargados",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          ordenActions.setOrden({
            orden: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener las ordenes",
        })
      );
    }
  };
};
export const RemoveUser = (ordenId, usuarioId, price, userName) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Removiendo participante",
        message: "Removiendo participante a la orden # " + ordenId,
      })
    );
    const updateOrderInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/orden/removeUser`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: userName,
            Id: ordenId,
            User: {
              Id: usuarioId,
            },
            Course: {
              Price: price,
            },
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo actualizar la orden");
      }
      const data = await response.json();
      return data;
    };
    try {
      await updateOrderInfo();
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar la orden",
        })
      );
    }
  };
};
export const AddUser = (ordenId, user, userName) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Agregando participante",
        message: "Agregando participante a la orden # " + ordenId,
      })
    );
    const updateOrderInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/orden/addUser`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: userName,
            Id: ordenId,
            User: {
              Name: user.name,
              LastName: user.lastName,
              Email: user.email,
              CellPhone: user.cellPhone,
              Country: user.country,
            },
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo actualizar la orden");
      }
      const data = await response.json();

      return data;

    };
    try {
      const response = await updateOrderInfo();

      
      if (response.result.errorCode === "OK") {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Participante Agregado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {

        
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
      await updateOrderInfo();
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar la orden",
        })
      );
    }
  };
};

export const DownloadPaymentTransfer = (ordenId, userName) => {
  return async (dispatch) => {
    const updateOrderInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}admin/orden/paymentReceipt`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: userName,
            Id: ordenId,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo encontrar el recibo de pago");
      }
      const data = await response.blob();
      const filename = response.headers.get("Content-Disposition");

      return { blob: data, filename };
    };
    try {
      const response = await updateOrderInfo();
      saveAs(response.blob, response.filename);
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar la orden",
        })
      );
    }
  };
};

export const CreateQuote = (quote, userName) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Creando Orden",
        message: "Creando orden al servidor.",
      })
    );


    const createOrderInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/orden/createQuote`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: userName,
            User: quote.user,
            Course: quote.course,
            CourseId: quote.course.id,
            DiscountCode: quote.discountCode,
            PaymentMethod: { id: 1 },
            Amount: quote.course.price,
            Category: "",
            ordenType: {
              Id: 2,
            },
            QuantityOfUsers: quote.quantity,
            Status: { id: 9 },
            RNC: quote.rnc,
            TaxBill: quote.taxBill,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );

      if (!response.ok) {

        throw new Error("No se pudo crear la orden");
      }

      const data = await response.json();
      return data;
    };
    try {
      const response = await createOrderInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          ordenActions.setQuote({
            quote: response.data,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          ordenActions.setOrden({
            orden: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo crear la orden",
        })
      );
    }
  };
};

export const SendQuote = (quote, file, userName) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Enviado Cotización",
        message: "Enviando cotización al servidor",
      })
    );
    let formData = new FormData();
    formData.append("Id", quote.orderNumber);
    formData.append("Name", quote.user.name);
    formData.append("LastName", quote.user.lastName);
    formData.append("Email", quote.user.email);
    formData.append("file", file);
    formData.append("UserName", userName);

    const createOrderInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/orden/quote`,
        {
          method: "POST",
          body: formData,
          headers: {
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Aqui>?");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await createOrderInfo();
      if (response.result.errorCode === "OK") {
        dispatch(ordenActions.restartState());
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          ordenActions.setOrden({
            orden: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "error",
        })
      );
    }
  };
};
export const SendBill = (bill, file, userName) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Enviado Cotización",
        message: "Enviando cotización al servidor",
      })
    );
    let formData = new FormData();
    formData.append("Id", bill.orderNumber);
    formData.append("Name", bill.user.name);
    formData.append("LastName", bill.user.lastName);
    formData.append("Email", bill.user.email);
    formData.append("file", file);
    formData.append("UserName", userName);

    const createOrderInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}admin/orden/bill`,
        {
          method: "POST",
          body: formData,
          headers: {
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Aqui>?");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await createOrderInfo();
      if (response.result.errorCode === "OK") {
        dispatch(ordenActions.restartState());
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          ordenActions.setOrden({
            orden: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "el lio",
        })
      );
    }
  };
};
export const UpdateOrdenStatus = (ordenId, statusId, userName) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Actualizando Estado",
        message: "Actualizando Estado de la Orden",
      })
    );
    const updateOrderInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}admin/orden/updateStatus`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: userName,
            Id: ordenId,
            OrdenStatusId: statusId,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo actualizar la orden");
      }
      const data = await response.json();
      return data;
    };
    try {
      await updateOrderInfo();
      dispatch(
        uiActions.showNotification({
          status: "success",
          title: "Datos Cargados",
          message: "Estado de la orden actualizado",
        })
      );
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar la orden",
        })
      );
    }
  };
};
export const UpdatePaymenMethod = (ordenId, paymentMethodId, userName) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Actualizando Método de pago",
        message: "Actualizando Método de pago de la Orden",
      })
    );
    const updateOrderInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/orden/updatePaymentMethod`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: userName,
            Id: ordenId,
            PaymentMethodId: paymentMethodId,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo actualizar la orden");
      }
      const data = await response.json();
      return data;
    };
    try {
      await updateOrderInfo();
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar la orden",
        })
      );
    }
  };
};
export const UpdateBillingInfo = (billing, userName) => {
  return async (dispatch) => {
   
    const updateOrderInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/orden/updateBillingInfo`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: userName,
            Id: billing.ordenId,
            BillNumber: billing.billNumber,
            BillName: billing.billName,
            BillAddress: billing.billAddress,
            BillCountry: billing.billCountry,
            BillEmail: billing.billEmail,
            BillPhone: billing.billPhone,
            BillAmount: billing.billAmount,
            Amount: billing.amount,
            DiscountCode: billing.discountCode,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );

      const data = await response.json();
      return data
    };
    try {
      const response = await updateOrderInfo();
      console.log("response", response);      
      
      dispatch(
        ordenActions.setOrden({
          orden: response.data,
        })
      );
    
    } catch (error) {
      console.log(error);
    
    }
  };
};

export const UploadFileOrder = (file, OrdenId, userName) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Subiendo comprobante de pago",
        message: "Subiendo comprobante de pago al servidor.",
      })
    );
    const updateOrderInfo = async () => {
      let formData = new FormData();
      formData.append("UserName", userName);
      formData.append("Id", OrdenId);
      formData.append("File", file);

      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/orden/paymentReceipt`,
        {
          method: "POST",
          body: formData,
          headers: {
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo actualizar la orden");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await updateOrderInfo();

      if (response.result.errorCode === "OK") {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Comprobante de pago",
            message: response.result.message,
          })
        );
      }
    } catch (error) {

      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar la orden",
        })
      );
    }
  };
};
export const CreateOrderWebinar = (courseId, userName) => {
  return async (dispatch) => {
    
    const createOrderInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/orden/createWebinar`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: userName,
            CourseId: courseId,
            
            QuantityOfUsers: 1,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo crear la orden");
      }
      const data = await response.json();

      return data;
    };
    try {
      const response = await createOrderInfo();

      if (response.result.errorCode === "OK") {
        localStorage.removeItem("token");
        localStorage.setItem("token", response.data.token);
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Inscripción exitosa",
            message: response.result.message,
          })
        );
      }
      setTimeout(() => {
        window.location.href = "/";
      }, 3000);
      if (response.result.errorCode === "Warning") {
        dispatch(
          ordenActions.setOrden({
            orden: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo crear la orden",
        })
      );
    }
  };
};

